import '../../styles/components/filters.scss';

class Filters extends HTMLElement {
  constructor() {
    super();
    const currentURL = new URL(window.location.href);
    this.sortBy = currentURL.searchParams.get('sort_by');

    this.sectionId = this.closest('.shopify-section').id.replace('shopify-section-', '');

    this.productsContainer = document.querySelector('[data-products-container]');
    this.collectionUrl = this.getAttribute('collection-url');
    this.filterForm = this.querySelector('form');
    this.filterGroups = Array.from(this.querySelectorAll('[data-filter-group-content]'));

    this.filterForm.addEventListener('change', this.formChange.bind(this));

    this.initializeDynamicItems();
  }

  initializeDynamicItems() {
    this.tagLinks = Array.from(this.querySelectorAll('[data-tag-link]'));
    this.resetTagGroups = Array.from(this.querySelectorAll('[data-reset-tag-group]'));
    this.removeTagElements = Array.from(this.querySelectorAll('[data-remove-tag]'));

    this.removeFiltersElements = Array.from(this.querySelectorAll('[data-remove-filter]'));

    this.removeFiltersElements.forEach(filter => {
      filter.addEventListener('click', this.removeFilter.bind(this));
    });
    this.tagLinks.forEach(tagLink => {
      tagLink.addEventListener('click', this.tagLinkClick.bind(this));
    });
    this.resetTagGroups.forEach(tagReset => {
      tagReset.addEventListener('click', this.resetTagGroup.bind(this));
    });
    this.removeTagElements.forEach(tagRemove => {
      tagRemove.addEventListener('click', this.removeTag.bind(this));
    });
  }

  tagLinkClick(event) {
    event.preventDefault();
    const tagInput = event.currentTarget.querySelector('[data-tag-input]');

    if(tagInput.checked) {
      tagInput.checked = false;
    }
    else {
      tagInput.checked = true;
    }
    
    this.refreshFilters(this.buildFilterUrl(), event.target.closest('[data-filter-group-content]'));
  }

  removeTag(event) {
    event.preventDefault();

    const tagToRemove = event.currentTarget.getAttribute('data-remove-tag');

    document.querySelector(`[data-tag-input][value="${tagToRemove}"]`).checked = false;

    this.refreshFilters(this.buildFilterUrl(), event.target.closest('[data-filter-group-content]'));
  }

  resetTagGroup(event) {
    event.preventDefault();

    const groupContainer = event.currentTarget.closest('[data-filter-group-content]');
    const groupInputs = Array.from(groupContainer.querySelectorAll('input'));

    groupInputs.forEach(input => {
      input.checked = false;
    });

    this.refreshFilters(this.buildFilterUrl(), event.target.closest('[data-filter-group-content]'));
  }

  formChange(event) {
    if(!event.target.hasAttribute('data-is-accordion')) {
      this.refreshFilters(this.buildFilterUrl(), event.target.closest('[data-filter-group-content]'));
    }
  }

  removeFilter(event) {
    event.preventDefault();

    const filterToRemove = event.currentTarget;
    const newFilterParams = new URL(filterToRemove.href).search.replace('?', '');

    if(filterToRemove.hasAttribute('data-clear-filter')) {
      const tagInputs = Array.from(this.querySelectorAll('[data-tag-input]'));

      tagInputs.forEach(input => {
        input.checked = false;
      });
    }

    this.refreshFilters(this.buildFilterUrl(newFilterParams), filterToRemove.closest('[data-filter-group-content]'));

    this.initializeDynamicItems();
  }

  
  async refreshFilters(url, groupElement) {
    this.classList.add('loading-state');
    this.productsContainer.classList.add('loading-state');
    if(groupElement) {
      groupElement.classList.add('loading');
    }

    const sectionUpdateResponse = await fetch(url);
    const sectionUpdateText = await sectionUpdateResponse.text();

    window.history.pushState(null, null, this.newURL);

    const tempElement = document.createElement('div');
    tempElement.innerHTML = sectionUpdateText;

    const newFilterElement = Array.from(tempElement.querySelectorAll('[data-filter-group-content]'));
    const newProducts = tempElement.querySelector('[data-products-container]');

    this.productsContainer.innerHTML = newProducts.innerHTML;
    this.filterGroups.forEach((group, index) => {
      group.innerHTML = newFilterElement[index].innerHTML;
    });

    this.initializeDynamicItems();

    this.classList.remove('loading-state');
    this.productsContainer.classList.remove('loading-state');
    if(groupElement) {
      groupElement.classList.remove('loading');
    }
  }

  /**
   * Returns the url for the new filters
   * 
   * @param {String} manualParams - manually specifies the new filter params
   */
  buildFilterUrl(manualParams) {
    let filterParams = new URLSearchParams(new FormData(this.filterForm));

    if(manualParams || manualParams === "") {
      filterParams = manualParams;
    } 

    const newURL = new URL(`${window.location.origin}${this.collectionUrl}${this.buildSelectedTags()}?${filterParams}`);

    if(this.sortBy) {
      newURL.searchParams.set('sort_by', this.sortBy);
    }

    this.newURL = newURL.toString();
    
    newURL.searchParams.set('section_id', this.sectionId)

    return newURL.toString();
  }

  buildSelectedTags() {
    const selectedTags = Array.from(this.querySelectorAll('[data-tag-input]:checked'));

    const tags = [];
    selectedTags.forEach(tag => {
      tags.push(tag.value);
    });


    return `/${tags.join('+')}`;
  }
}

try {
  customElements.define('collection-filters', Filters);
}
catch(e) {
  console.log("collection-filters already defined", e)
}


class FilterToggle extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      document.querySelector('[data-filter-container]').classList.toggle('opened');
      
      Array.from(document.querySelectorAll('filter-toggle')).forEach(toggle => {
        toggle.classList.toggle('opened')
      })
    })
  }
}

try {
  customElements.define('filter-toggle', FilterToggle);
}
catch(e) {
  console.log("filter-toggle already defined", e)
}


class FilterSortBy extends HTMLElement {
  constructor() {
    super();

    this.productsContainer = document.querySelector('[data-products-container]');
    this.select = this.querySelector('select');

    this.select.addEventListener('change', this.selectChange.bind(this));
  }

  async selectChange() {
    this.buildNewUrl();

    document.querySelector('collection-filters').sortBy = this.select.value;

    this.productsContainer.classList.add('loading-state');

    const sectionUpdateResponse = await fetch(this.newURL);
    const sectionUpdateText = await sectionUpdateResponse.text();

    window.history.pushState(null, null, this.newURL);

    const tempElement = document.createElement('div');
    tempElement.innerHTML = sectionUpdateText;

    const newProducts = tempElement.querySelector('[data-products-container]');

    this.productsContainer.innerHTML = newProducts.innerHTML;

    this.productsContainer.classList.remove('loading-state');
  }

  buildNewUrl() {
    const newURL = new URL(window.location.href);

    newURL.searchParams.delete('sort_by');
    newURL.searchParams.delete('page');
    newURL.searchParams.append('sort_by', this.select.value);

    this.newURL = newURL;
  }
}

try {
  customElements.define('filter-sort-by', FilterSortBy);
}
catch(e) {
  console.log("filter-sort-by already defined", e)
}